import React,{Component} from 'react';

import { Button} from "react-bootstrap";
import { register } from "../../services/GameServices";
class CreateUser extends Component {
    constructor(props){
        super(props);
        this.state={
            name:'',
            pass:'',
            con:''
        }
    }
    componentDidMount(){
      console.log("Create Usercomponent");
    }
    handleNameChange= (e)=> {
        this.setState({ name: e.target.value });
      }
    handlePassChange= (e)=> {
    this.setState({ pass: e.target.value });
    }
    handleConfirmChange= (e)=> {
      this.setState({ con: e.target.value });
      }
    error = (msg) => {
        console.log('Create user error alert');
        alert(msg);
    }
    authenticate = () => {
        console.log("Creating new user");
        let hist= this.props.history;
        if((this.state.con ===this.state.pass)){
          register({
            email: this.state.name,
            password: this.state.pass
          }).then(function(resp, err) {
            if (err) {
              console.log("an error");
              console.log(err);
              this.error("User name is not unique");
              //call error message 
            } 
            else if (resp) {
              if (resp.data.err) {
                console.log("response error", resp.data.err);
                this.error("Password shall be at least 8 characters");
              } 
              else {
                console.log("response is cool ", resp.data.data);
                
              hist.push({
                    pathname:`/`
                  });
                
              }
              console.log(resp);
            } 
            else {
              console.log("No response what so ever");
              this.error("Please wait and try again later");
            }
          }).catch(err =>{
            console.log("trouble Creating User " ,err);
            this.error("Trouble Creating User Try again");
        })
        }
        else{
          this.error("Check if Passwords are the same");
        }
      
        
      }
    render(){
        return(
            <div style={{textAlign:"center"}}> 
                <h1> 
                  Create User
                </h1>
                <div style={{ padding: 20 }}>
                    <h3>Email</h3>
                    <input type="email" placeholder="Email"
                        onChange={this.handleNameChange}  />
                    <h3>New Password</h3>
                    <input type="password" placeholder="New Password"
                        onChange={this.handlePassChange}  />
                        
                    <h3>Confirm Password</h3>
                    <input type="password" placeholder="Confirm Password"
                        onChange={this.handleConfirmChange}  />
                    <br />
                    <Button style={{ marginTop: 17 }} bsSize="large" bsStyle="info" onClick={this.authenticate}>Create</Button>
                </div>

            </div>
        )
    }
}
export default CreateUser;


// WEBPACK FOOTER //
// ./src/views/Quiz/CreateUser.jsx